import { useCostLinesStore } from "entities/CostLines";
import { useRequestPersistedStore, useRequestStore } from "entities/Request";
import { useInternalOrderStore } from "features/SelectInternalOrder";
import { useInternalOrders } from "features/SelectInternalOrder/api/hooks/useInternalOrders";
import { memo, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import ReactSelect from "react-select";
import { REQUEST_TYPES, ROLES } from "shared/config";
import {
  reactSelectStyles,
  reactSelectTheme,
} from "shared/config/react-select";
import { CopyToClipboardButton } from "shared/ui";

function SelectInternalOrder({ ...props }) {
  const request = useRequestStore((state) => state.request);
  const costLines = useCostLinesStore((state) => state.costLines);
  const userRole = useRequestPersistedStore(
    (state) => state.viewRequestAs.role
  );
  const setInternalOrder = useInternalOrderStore(
    (state) => state.setInternalOrder
  );
  const [selectedOption, setSelectedOption] = useState(null);
  const { data: internalOrders, isLoading } = useInternalOrders(
    request?.id,
    userRole
  );

  const handleSelectChange = (selected) => {
    setSelectedOption(selected);
    setInternalOrder(selected);
  };

  const getStoredInternalOrder = () => {
    if (
      request?.type === REQUEST_TYPES.EXPENSE ||
      request?.type === REQUEST_TYPES.TRAVEL
    ) {
      const firstCostLine = costLines[0];
      return firstCostLine?.internal_order?.data?.id
        ? {
            value: firstCostLine.internal_order?.data?.id,
            label: firstCostLine.internal_order?.data?.number,
          }
        : null;
    } else if (request?.type === REQUEST_TYPES.EUROCARD) {
      const firstSubCost =
        request?.credit_cards_costs_transactions?.data[0]
          ?.credit_cards_costs_transaction_sub_costs?.data[0];
      if (firstSubCost?.posting_internal_order)
        return {
          value: firstSubCost.posting_internal_order,
          label: firstSubCost.posting_internal_order,
        };
      else return null;
    }
  };

  useEffect(() => {
    if (internalOrders?.length && request) {
      const storedInternalOrder = getStoredInternalOrder();
      if (storedInternalOrder) {
        handleSelectChange(storedInternalOrder);
      } else {
        handleSelectChange({
          label: internalOrders[0].number,
          value: internalOrders[0].id,
        });
      }
    }
    return () => {
      setInternalOrder(null);
    };
  }, [internalOrders, request]);

  const options = internalOrders?.map((internalOrder) => ({
    label: internalOrder.number,
    value: internalOrder.id,
  }));

  const isCopyable = userRole === ROLES.ACCOUNTS_PAYABLE;

  return (
    <Form.Group>
      <Form.Label className={isCopyable ? "p-0 my-0 mx-2" : ""}>
        Internal order
        {isCopyable && (
          <CopyToClipboardButton valueToCopy={selectedOption?.label} />
        )}
      </Form.Label>
      <ReactSelect
        value={selectedOption}
        theme={reactSelectTheme}
        styles={reactSelectStyles}
        options={options}
        isLoading={isLoading}
        onChange={handleSelectChange}
        {...props}
      />
    </Form.Group>
  );
}

export default memo(SelectInternalOrder);
